import type { WooOrder } from "../types";
import {
  ORDER_STATUS_GROUPS,
  getOrderStatusGroupId,
  type OrderStatusGroupId,
} from "../constants/orderStatusConfig";

export function isPendingOrder(order: WooOrder): boolean {
  return getOrderStatusGroupId(order.status, order.needsPayment) === "unpaid";
}

export function isPaidOrder(order: WooOrder): boolean {
  if (order.datePaid) return true;
  return getOrderStatusGroupId(order.status, order.needsPayment) === "paid";
}

export function isHistoryOrder(order: WooOrder): boolean {
  return !isPendingOrder(order);
}

export function filterOrdersByGroup(
  orders: WooOrder[],
  groupId: OrderStatusGroupId,
): WooOrder[] {
  return orders.filter(
    (order) =>
      getOrderStatusGroupId(order.status, order.needsPayment) === groupId,
  );
}

export function getOrderStatusLabel(status: string): string {
  const labels: Record<string, string> = {
    pending: "Aguardando pagamento",
    "on-hold": "Aguardando pagamento",
    failed: "Falha no pagamento",
    processing: "Pagamento confirmado",
    completed: "Concluído",
    cancelled: "Cancelado",
    refunded: "Reembolsado",
  };
  return labels[status] ?? status;
}

export function getOrderStatusColor(
  status: string,
): "warning" | "info" | "success" | "error" | "default" {
  const groupId = getOrderStatusGroupId(status);
  if (groupId === "unpaid") return "warning";
  if (status === "processing") return "info";
  if (status === "completed") return "success";
  if (status === "failed") return "error";
  if (groupId === "cancelled") return "default";
  return "default";
}

export function formatOrderDate(dateCreated: string): string {
  const date = new Date(dateCreated);
  if (Number.isNaN(date.getTime())) return dateCreated;
  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
}

export { ORDER_STATUS_GROUPS, getOrderStatusGroupId };
